<div class="login-new" id="login-container" (keydown.enter)="!buttonConfig?.disabled && onLoginSubmit()">
  <div>
    <h5 class="onboarding-title" id="login-title">{{"login_title" | translate}}</h5>
    <p class="onboarding-subtitle" id="login-subtitle">{{"login_sub_title" | translate}}</p>
  </div>
  <div class="one-col-grid input-no-margin">
    <ds-textbox
      [textboxInput]="emailConfig"
      (valueChange)="onEmailChange($event)"
      (blur)="onEmailIdEntered()"
    ></ds-textbox>
    <div class="one-col-grid gap-8 input-no-margin">
      <ds-textbox
      [textboxInput]="passwordConfig"
      (valueChange)="onPasswordChange($event)"
      ></ds-textbox>
        <ds-checkbox
          [checkboxInput]="rememberMeCheckboxConfig"
          (checkedChange)="onRememberChanged($event)">
        </ds-checkbox>
    </div>
    <ds-button
      [buttonInput]="buttonConfig"
      (btnClick)="onLoginSubmit()"
    ></ds-button>
  </div>
  @if(showCaptcha || showCaptchaMessage){<div class="captcha-section" id="captcha-section">
    @if(showCaptchaMessage){<p class="captcha-error" id="captcha-error-message">{{ invalidCaptcha }}</p>}
    @if(showCaptcha){<re-captcha [siteKey]="siteKey" (resolved)="onCaptchaResolved($event)" size="60" id="captcha-container"></re-captcha>}
  </div>}
  <hr class="hr-border-muted"> 
  <div class="login-links ">
    <a href="/forgotpassword" class="link" id="forgot-password-link">{{ "forgot_password" | translate }}?</a>
    <p id="signup-text">{{ "dont_have_expenseondemand_account" | translate }}
      <a (click)="gotoSignUp()" class="link" id="register-link">{{ "register_now" | translate: { trialDays: trialDays } }}</a></p>
  </div>
</div>
<app-mfa-popup #mfaPopup
  [username]="username"
  [param]="params"
  qrSecret="{{qrSecret}}"
  (continue)="continueLogin()"
  (signup)="gotoSignUp()">
</app-mfa-popup>
